import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import DocFullScreenExample from '../UI/DocFullScreenExample';
import StickyBarExample from '../examples/StickyBar';
const StickyBarExampleSource = require('!!raw-loader!../examples/StickyBar');
import StickyBarWithoutLogoExample from '../examples/StickyBarWithoutLogo';
const StickyBarWithoutLogoExampleSource = require('!!raw-loader!../examples/StickyBarWithoutLogo');
const StickyBarPage = () => (<div>
        <Helmet title="StickyBar"/>
        <h3>StickyBar</h3>
        <DocFullScreenExample className="px-11 overflow-auto">
            <StickyBarExample />
        </DocFullScreenExample>
        <pre>
            <PrismCode className="language-jsx">{StickyBarExampleSource}</PrismCode>
        </pre>
        <Helmet title="StickyBar without logo"/>
        <h3>StickyBar without logo</h3>
        <DocFullScreenExample className="px-11 overflow-auto">
            <StickyBarWithoutLogoExample />
        </DocFullScreenExample>
        <pre>
            <PrismCode className="language-jsx">{StickyBarWithoutLogoExampleSource}</PrismCode>
        </pre>
    </div>);
export default StickyBarPage;
